import script from "./ToDoDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./ToDoDemo.vue?vue&type=script&setup=true&lang=js"

import "./ToDoDemo.vue?vue&type=style&index=0&id=7fa7574a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fa7574a"]])

export default __exports__